import { render, staticRenderFns } from "./partnerDetailsmain.vue?vue&type=template&id=28cd1286"
import script from "./partnerDetailsmain.vue?vue&type=script&lang=js"
export * from "./partnerDetailsmain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports